exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.createReservationTopArea .dropdown .dropdown-toggle {\n  height: 1.8125rem;\n}\n.createReservationTopArea .dropdown .dropdown-toggle .selected-tag {\n    height: 1.8125rem;\n    margin: 0;\n    line-height: 1.5625rem;\n}\n.createReservationTopArea .dropdown .dropdown-toggle .open-indicator {\n    height: 1.0625rem;\n}\n.resourceSelectorNewReservation .v-select .dropdown-toggle .vs__actions {\n  top: 0.1875rem;\n}\n.resourceSelectorNewReservation .v-select .vs__selected-options input.form-control[disabled] {\n  height: 1.69rem;\n  line-height: 1.69rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2a040eb8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume/Details/TopArea.vue
// module id = 2880
// module chunks = 0